import React from "react";
import { Building2, ClipboardCheck, FileText, FolderKanban, CalendarClock, ReceiptText, LayoutGrid, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

const items = [
  { icon: ClipboardCheck, t: "Kostnadsfri statusbedömning", d: "Vi går igenom fastigheternas tak och sammanställer skicket." },
  { icon: FileText, t: "Offert per fastighet", d: "Tydlig prisbild för varje enskild fastighet – inga klumpsummor." },
  { icon: FolderKanban, t: "Digital dokumentation", d: "Foton och rapporter samlade och lätta att dela internt." },
  { icon: CalendarClock, t: "Underhållsplan", d: "En långsiktig plan så taken sköts i rätt tid, år efter år." },
  { icon: LayoutGrid, t: "Samlad projektöversikt", d: "Se status för hela beståndet på ett och samma ställe." },
  { icon: ReceiptText, t: "Fakturering per fastighet", d: "Enkel administration med fakturor uppdelade per objekt." },
];

export default function B2B() {
  return (
    <section id="foretag" className="bg-white py-16 lg:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal grid lg:grid-cols-[1fr_1.1fr] gap-10 items-center">
          <div>
            <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">BRF · Fastighetsägare · Företag · Samfälligheter</p>
            <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">
              Takunderhåll för hela ditt fastighetsbestånd
            </h2>
            <p className="mt-4 text-2xl font-bold text-[#1B45C4]">En kontakt för hela ditt fastighetsbestånd.</p>
            <p className="mt-4 text-slate-600 text-lg">
              Slipp jaga olika entreprenörer. HPR sköter kontroll, behandling, dokumentation och
              återkommande underhåll för alla era tak – strukturerat och spårbart.
            </p>
            <Button asChild className="mt-8 rounded-full h-14 px-8 py-3 bg-[#1B45C4] hover:bg-[#12308f] text-white font-semibold shadow-lg shadow-[#1B45C4]/25">
              <a href="#kontakt" data-testid="b2b-cta">Boka fastighetsgenomgång <ArrowRight className="ml-2 w-5 h-5" /></a>
            </Button>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {items.map((it) => (
              <div key={it.t} className="rounded-2xl bg-[#f0f7ff] p-6 ring-1 ring-[#dbeafe]">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#1B45C4]/10">
                  <it.icon className="w-5 h-5 text-[#1B45C4]" />
                </div>
                <h3 className="mt-4 font-bold text-slate-900">{it.t}</h3>
                <p className="mt-1.5 text-sm text-slate-600">{it.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
